import * as Yup from 'yup';
import {ITeamRole} from '@/utils/enums';
import {emailSchema} from '@/utils/validation';

export interface IOrganization {
	firstName: string;
	lastName: string;
	role: ITeamRole;
	email: string;
	id?: number;
}
export interface IFormProps {
	organization: IOrganization;
}

export const defaultInitialValues: IOrganization = {
	firstName: '',
	lastName: '',
	email: '',
	role: ITeamRole.STANDART,
};

export const validationSchema = () => {
	return Yup.object().shape({
		firstName: Yup.string().required('First name is required').trim(),
		lastName: Yup.string().required('Last name is required').trim(),
		email: emailSchema,
		role: Yup.string().required('Role is required'),
	});
};
